import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class IsUserNotLoggedInGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  canActivate(): boolean {
    const isUserAuthenticated = this.authenticationService.isUserAuthenticated();
    if (isUserAuthenticated) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
